// extracted by mini-css-extract-plugin
export default {"cleanFilters":"SearchFilters_cleanFilters__DLrfq","title":"SearchFilters_title__JMs4r"};